import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  overflow-x: hidden;
`;

export const Top = styled.div`
  padding: 10px;
`;

export const Item = styled.div`
  padding: 3px 10px;
  color: #aab;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:nth-child(odd) {
    background-color: rgba(225, 225, 255, 0.1);
  }

  &:hover {
    color: pink;
  }

  &.selected {
    color: gold;
  }
`;

export const Title = styled.div`
  flex: 1;
`;

export const Params = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
`;
